import {
    Configuration,
    Interpretation,
    InterpretationControllerApi,
    TableDataResponse,
} from "@inode/pilot-client-typescript-fetch";
import { baseCfg } from "#services/pilotService/baseCfg";

export class PilotInterpretationService {
    private service: InterpretationControllerApi;
    private url: string;
    private config: Configuration;
    private userId: string;

    constructor(url: string, userId: string) {
        this.url = url;
        this.userId = userId;
        this.config = new Configuration(baseCfg(url, userId));
        this.service = new InterpretationControllerApi(this.config);
    }

    list(): Promise<Array<Interpretation>> {
        return this.service.listInterpretations({
            X_Reference_ID: this.userId,
        });
    }

    get(id: number): Promise<Interpretation> {
        // TODO take care of response status 200, 201, 202 etc
        return this.service.getInterpretation({
            id,
            X_Reference_ID: this.userId,
        });
    }

    getTable(id: number): Promise<TableDataResponse> {
        return this.service.getInterpretationTable({
            id,
            X_Reference_ID: this.userId,
        });
    }
}
